import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { PAGE_ICONS, PAGE_ROUTES } from 'pages/AnnualUserAccessReview/_const';
import NavCard from '../../components/NavCard';

/**
 * Templated navigation card for Delegation functionality for User Access Review Directory
 * @param {object[]} props.staffData list of employees reporting to logged in user
 * @returns navigation card for delegation
 */
const DelegateCard = ({ staffData = [] }) => {
	const history = useHistory();

	return staffData.length > 0 ? (
		<NavCard
			title={'Delegate'}
			icon={<PAGE_ICONS.DELEGATE color='secondary' />}
			role={'Administrative'}
			description={
				'Allow annual user access review responsibilities to be performed by another user.'
			}
			onClick={() => history.push(PAGE_ROUTES.DELEGATE)}
		/>
	) : null;
};

DelegateCard.propTypes = {
	staffData: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default DelegateCard;
